import { post, get } from '../utils/request';
import { GradeQueryResult, ReportVerifyResult, VerificationReport, PaginatedResponse } from '../types';

// 查询成绩
export async function queryGrades(params: {
  studentNo?: string;
  idNumber?: string;
  name?: string;
  captchaToken?: string;
}): Promise<GradeQueryResult> {
  return post<GradeQueryResult>('/query/grades', params);
}

// 验证学生身份
export async function verifyStudentIdentity(params: {
  studentNo?: string;
  idNumber?: string;
  name?: string;
}): Promise<{
  studentId: string;
  studentNo: string;
  name: string;
  campusName: string;
}> {
  return post('/query/verify', params);
}

// 生成验证报告
export async function generateReport(studentId: string, validityDays?: number): Promise<{
  reportId: string;
  reportNo: string;
  qrCodeUrl: string;
  verifyLink: string;
  validityDays: number;
  expiredAt: string;
  sealText: string;
  sealImageUrl: string;
}> {
  return post('/reports', { studentId, validityDays });
}

// 验证报告
export async function verifyReport(reportNo: string): Promise<ReportVerifyResult> {
  return get<ReportVerifyResult>(`/verify/${reportNo}`);
}

// 获取报告列表
export async function getReportList(params?: any): Promise<PaginatedResponse<VerificationReport>> {
  return get<PaginatedResponse<VerificationReport>>('/reports', params);
}

// 下载报告
export async function downloadReport(reportId: string): Promise<{ pdfUrl: string; reportNo: string }> {
  return get<{ pdfUrl: string; reportNo: string }>(`/reports/${reportId}/download`);
}
